import { render } from "./SystemSettingsActions.vue?vue&type=template&id=935986e2&scoped=true"
import script from "./SystemSettingsActions.vue?vue&type=script&lang=js"
export * from "./SystemSettingsActions.vue?vue&type=script&lang=js"

import "./SystemSettingsActions.vue?vue&type=style&index=0&id=935986e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-935986e2"]])

export default __exports__